import { render, staticRenderFns } from "./WeitzerLogo.vue?vue&type=template&id=4c1d11b0&scoped=true&"
var script = {}
import style0 from "./WeitzerLogo.vue?vue&type=style&index=0&id=4c1d11b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d11b0",
  null
  
)

export default component.exports